import React, { useState } from 'react';
import Dropdown from 'react-bootstrap/Dropdown';

const AutoComplete = ({ inputRef, value, setValue, suggestions, placeholder, focusInput, tryCreateTag, tryRemoveLastTag, inputStyle }) => {
    const [activeIndex, setActiveIndex] = useState(-1);
    const [filteredSuggestions, setFilteredSuggestions] = useState([]);
    const [showSuggestions, setShowSuggestions] = useState(false);
    const numberOfSuggestionsToShow = 5;

    const onChange = (event) => {
        const newValue = event.target.value;

        if (suggestions && suggestions.length) {
            if (numberOfSuggestionsToShow) {
                setFilteredSuggestions(
                    suggestions.filter((s) => s.toLowerCase().indexOf(newValue.toLowerCase()) === 0).slice(0, numberOfSuggestionsToShow)
                );
            } else {
                setFilteredSuggestions(suggestions.filter((s) => s.toLowerCase().indexOf(newValue.toLowerCase()) === 0));
            }
        }

        setActiveIndex(-1);
        setShowSuggestions(newValue !== '');
        setValue(newValue);
    };

    const onMouseDown = () => {
        if (activeIndex >= 0) {
            setValue(filteredSuggestions[activeIndex]);
            setActiveIndex(0);
            setFilteredSuggestions([]);
            setShowSuggestions(false);
        }
    };

    const onKeyDown = (event) => {
        // Enter selects active index and creates tag
        if (event.keyCode === 13) {
            if (activeIndex >= 0) {
                setValue(filteredSuggestions[activeIndex]);
            }
            setShowSuggestions(false);
            setActiveIndex(-1);
            tryCreateTag();
            event.preventDefault();
        }

        // Backspace removes last tag
        if (event.keyCode === 8) {
            if (value === '') {
                tryRemoveLastTag();
                focusInput();
                event.preventDefault();
            }
        }

        // Escape closes
        if (event.keyCode === 27) {
            setShowSuggestions(false);
            setActiveIndex(-1);
            event.preventDefault();
        }

        // Up-arrow moves up in list
        else if (event.keyCode === 38) {
            if (activeIndex > -1) {
                setActiveIndex(activeIndex - 1);
            }
            event.preventDefault();
        }

        // Down-arrow moves down in list
        else if (event.keyCode === 40) {
            if (activeIndex < filteredSuggestions.length - 1) {
                setActiveIndex(activeIndex + 1);
            }
            event.preventDefault();
        }
    };

    const onBlur = () => {
        setShowSuggestions(false);
        tryCreateTag();
    };

    return (
        <div className={'autocomplete'}>
            <input
                ref={inputRef}
                placeholder={placeholder}
                value={value}
                onChange={onChange}
                onKeyDown={onKeyDown}
                onBlur={onBlur}
                style={inputStyle}
            />
            {showSuggestions && filteredSuggestions.length > 0 && (
                <Dropdown>
                    <Dropdown.Menu show className='suggestions'>
                        {filteredSuggestions.map((suggestion, index) => {
                            let className = 'suggestion';
                            if (index === activeIndex) {
                                className += ' suggestion-active';
                            }
                            return (
                                <Dropdown.Item
                                    onMouseDown={onMouseDown}
                                    onMouseEnter={() => setActiveIndex(index)}
                                    className={className}
                                    key={index}
                                    eventKey={index}>
                                    {suggestion}
                                </Dropdown.Item>
                            );
                        })}
                    </Dropdown.Menu>
                </Dropdown>
            )}
        </div>
    );
};

export default AutoComplete;
